/**
 * ReportTemplate entity class
 */

import moment from 'moment'

/**
 * ReportTemplateFactory
 * returns ReportTemplate entity class
 *
 * @class ReportTemplateFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportTemplate} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportTemplateFactory
 */
/* @ngInject */
export default function ReportTemplateFactory ($http, Entity, onOffMixin, alertLiteSvc) {
  /* === ReportTemplate class === */

  /**
   * ReportTemplate model
   *
   * @class ReportTemplate
   * @classdesc ReportTemplate model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @param {Object} [object] - initial object, containing ReportTemplate entity fields
   * @return {models.ReportTemplate} ReportTemplate entity
   */
  function ReportTemplate () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportTemplate.prototype = Object.create(Entity.prototype)
  ReportTemplate.prototype.constructor = ReportTemplate

  /* === User instance methods & fields === */

  Object.assign(ReportTemplate.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ReportTemplate#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      reportType: String,
      networkId: Number,
      networks: [],
      filterList: ['Filter'],
      fieldList: [String],
      createdTime: moment,
      createdBy: String
    },

    /**
     * url template
     *
     * @memberof models.ReportTemplate#
     * @type {String}
     */
    _urlTemplate: 'api/reporttemplates/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.ReportTemplate#
     * @type {String}
     */
    _publicUrlTemplate: 'reporttemplates/{{::id}}',

    /**
     * Generate template
     *
     * @private
     */
    _generate: function () {
      return $http.post(
        this._url + '?generate',
        {templateId: this.id}
      ).catch(alertLiteSvc.alertError)
    }

  }, onOffMixin)

  /* === User static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(ReportTemplate, Entity)
  ReportTemplate._name = 'ReportTemplate'
  ReportTemplate.init()

  // permissions
  // ReportTemplate.access = {
  //   view: 'viewReport',
  //   create: 'createReport',
  //   delete: 'deleteReport'
  // }

  return ReportTemplate
}
